import { flow } from "fp-ts/lib/function";

import { MetricField } from "../../gql-generated/types";

import { formatPercentValue } from "./formatPercentValue";

export { formatNumericValue as TOTAL_VALUE_DEFAULT_FORMATTER } from "./formatNumericValue";

export type TotalValueFormatter = (totalValue: number) => string;

export const totalValueFormattersMap: Partial<Record<MetricField, TotalValueFormatter>> = {
    [MetricField.LensLongPlayRatio]: (totalValue: number) => {
        if (totalValue <= 0) {
            return "-";
        }

        return flow((totalValue: number) => totalValue * 100, formatPercentValue())(totalValue);
    },
};
